<template>
  <div>
    <!-- <div
      class="absolute-center welcome flex-row"
     
      v-if="textTatSimpleId"
    >
      <img src="../../assets/images/index.png" alt="welcome" />
    </div> -->
    <div style="margin: 30px;margin-left: 0;" class="flex" v-if="textTatSimpleId">
        <el-select v-model="value" placeholder="请选择机构进行查询" style="margin-left: 30px;margin-right: 30px" @change="getDataNew" filterable >
    <el-option
      v-for="item in typeTwo"
      :key="item"
      :label="item.tatName"
      :value="item.id">
    </el-option>
  </el-select>

    </div>
    <div class="flex-row ">
  <div class="flex-row welcomeTwo leftBox  flow-wrap">
      <!-- 机构账户金额模块 -->
      <div class="backFFF">
        <div class="welcomeTitle">机构账户金额</div>
        <div class="textCenter">￥ {{ selfMoneyTwo }}</div>
      </div>
      <!-- 用户账户余额模块 -->
      <div class="backFFF">
        <div class="welcomeTitle">用户账户余额</div>
        <div class="textCenter">￥ {{ saveData.money.memMoney }}</div>
      </div>
      <!-- 机构利润账户 -->
         <div class="backFFF">
        <div class="welcomeTitle">机构利润账户</div>
        <div class="textCenter">￥ {{ saveData.money.money  }}</div>
      </div>
       <!-- 授信额度 -->
         <div class="backFFF">
        <div class="welcomeTitle">授信额度</div>
        <div class="textCenter">￥ {{ selfMoney }}</div>
      </div>
      <!-- 浮动比例 -->
      
      
      <div class="backFFF">
        <div class="welcomeTitle">浮动比例</div>
        <div class="textCenter">{{ saveData.money.fudongbili }}%</div>
      </div>
     
    </div>
   <!-- 右侧50% -->
    <div class="leftBox welcomeTwo">
       <div class="backFFFCopy">
        <div class="welcomeTitle">机构活动</div>
        <div  class="flex-col absolute-center flex-1" style="overflow: auto">
          <div
            class="textCenterCopy"
            v-for="(item, index) in saveData.list"
            :key="index"
          >
            {{ item.activityName }}
          </div>
        </div>
      </div>

    </div>
    </div>
  
    <!-- 新加右边盒子 -->
   
  </div>
</template>

<script>
import welcome from "service/PowerUserService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import activity from "service/Ainstitution";
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
export default {
  name: "welcome",
  data() {
    return {
      saveData: {},
      selfMoney: '',
      selfMoneyTwo: '',
      typeTwo: [],
      value: ''
    };
  },
  computed: {
    ...mapGetters(["tatSimpleId", "textTatSimpleId"]),
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.getData();
    this.getTypeTwo()
  },
  methods: {
    getTypeTwo() {
      this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            res.contents.rows.forEach((item) => {
              (item.dictValue = item.id), (item.dictKey = item.tatName);
            });
            this.typeTwo = [...this.typeTwo, ...res.contents.rows];
           
           
          });
        },
        "信息获取失败"
      );
    },
    getData() {
      this.doLoad(
        welcome.welcomeData,
        { tatSimpleId: this.tatSimpleId, type: 1 },
        (res) => {
          this.doCheck(res, (res) => {
            this.saveData = res.contents;
            this.saveData.money.money = (this.saveData.money.money / 100).toFixed(2);
            this.saveData.money.memMoney = (this.saveData.money.memMoney / 100).toFixed(2);
            this.selfMoneyTwo = (parseFloat(this.saveData.money.money) + parseFloat(this.saveData.money.memMoney)).toFixed(2)
            this.selfMoney = Math.floor(this.saveData.money.memMoney * (this.saveData.money.fudongbili / 100))
            console.log(res, "res");
          });
        }
      );
    },
     getDataNew() {
      this.doLoad(
        welcome.welcomeData,
        { tatSimpleId: this.value, type: 1 },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res,'res')
            this.saveData = res.contents;
            this.saveData.money.money = (this.saveData.money.money / 100).toFixed(2);
            this.saveData.money.memMoney = (this.saveData.money.memMoney / 100).toFixed(2);
             this.selfMoneyTwo = (parseFloat(this.saveData.money.money) + parseFloat(this.saveData.money.memMoney)).toFixed(2)
            this.selfMoney = Math.floor(this.saveData.money.memMoney * (this.saveData.money.fudongbili / 100))
            console.log(res, "res");
          });
        }
      );
    },
    // handleClose(done) {
    //   this.$confirm("确认关闭？")
    //     .then((_) => {
    //       done();
    //     })
    //     .catch((_) => {});
    // },
  },
};
</script>

<style scoped>
.welcome {
  padding: 10vh;
}
/deep/.el-select {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Welcome.vue